import { enqueueSnackbar } from "notistack";

export function unknownError(error) {
  console.error(error);

  // Ignore canceled request
  if (error?.code === "ERR_CANCELED") return;

  // Ignore network errors
  if (
    error?.code === "ERR_NETWORK" ||
    error?.message?.toLowerCase().includes("network error") ||
    (error?.isAxiosError && !error?.response)
  ) {
    return;
  }
  if (error?.response?.status === 401) {
    console.error(error);
    return;
  }
  console.log(error, "");
  if (error?.response?.status === 403) {
    enqueueSnackbar("Permission Denied!", {
      variant: "warning",
      style: {
        backgroundColor: "#ff6600ff",
        color: "#fff",
      },
    });
    return;
  }

  return enqueueSnackbar("Something went wrong", { variant: "error" });
}
